<ng-template #content let-modal>

    <div class="modal-header bg-dark">
        <h5 class="modal-title" id="changeStateLabel">Ticket</h5>
        <button type="button" class="close text-light" (click)="modal.dismiss('Cross click')">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body">
        <div class="row justify-content-center">
            <div class="col-12">
                <iframe [src]="base64" *ngIf="base64" frameborder="0" width="100%" height="500px">
                  </iframe>
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-info" (click)="enviarMail()" *ngIf="Pedido.cliente.email && false"><i
                class="fas fa-paper-plane"></i> Enviar por Correo</button>
        <button type="button" class="btn btn-success" (click)="enviarWsp()" *ngIf="Pedido.cliente.telefono"><i
                class="fab fa-whatsapp"></i> Enviar por Whatsapp</button>
        <button type="button" class="btn btn-outline-danger" (click)="modal.dismiss('close')"><i
                class="fas fa-times"></i> Cerrar</button>
    </div>
</ng-template>

<button type="button" class="btn btn-outline-primary {{cssClass}}" title="Ver Ticket" (click)="open()" *ngIf="showButton">
    <i class='fas fa-receipt'></i>
</button>